module.exports = __webpack_public_path__ + "img/clip-payment-method-of-your-choice-we-accept-everything.1b562612.png";